import i18n from 'i18nextInstance';

const messages = {
    hasLengthGreaterThan: length => `${ i18n.t('Máximo') } ${ length } ${ i18n.t('caracteres') }`,
    hasLengthLessThan: length => `${ i18n.t('Mínimo') } ${ length } ${ i18n.t('caracteres') }`,
    hasLengthUpTo: length => `${ i18n.t('Máximo') } ${ length } ${ i18n.t('caracteres') }`,
    invalidMail: i18n.t('Mail inválido'),
    onlyLetters: i18n.t('Sólo letras'),
    onlyNumbers: i18n.t('Sólo números'),
    reachedLenght: i18n.t('Largo superado'),
    required: i18n.t('Requerido')
};

export default messages;
